import { attendanceConstants } from '../constants/attendanceConstants';


var viewActions = require ('../../../store/view.actions');

var attendanceService = require ('../apis/attendanceApi');

export const attendanceActions = {
  getCourseAttendance, deleteAttendance, getAttendanceTypes, postAttendance, 
  getCourseAttendanceStatus, postCourseAttendanceStatus, getHolidays
};  


function getHolidays( token, calendarID  ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getHolidays',true)) ;
          attendanceService.getHolidays( token, calendarID )
          .then( json => {
              dispatch({
                type: attendanceConstants.LOAD_HOLIDAYS,
                holidays: json
              })
              dispatch(viewActions.isLoadingModule('getHolidays',false)) ;
          } )
          
  }
}


function getAttendanceTypes( token  ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getAttendanceTypes',true)) ;
          attendanceService.getAttendanceTypes( token )
          .then( json => {
              dispatch({
                type: attendanceConstants.LOAD_ATTENDANCE_TYPES,
                attendanceTypes: json
              })
              dispatch(viewActions.isLoadingModule('getAttendanceTypes',false)) ;
          } )
          
  }
}


function postCourseAttendanceStatus( token, courseID, data ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('postCourseAttendanceStatus',true)) ;
          attendanceService.postCourseAttendanceStatus ( token, courseID, data )
          .then( json => {
              dispatch({
                type: attendanceConstants.ADD_ATTENDANCE_STATUS,
                added: json
              })
              dispatch(viewActions.isLoadingModule('postCourseAttendanceStatus',false)) ;
          } )
          
  }
}

function getCourseAttendanceStatus( token, courseID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseAttendanceStatus',true)) ;
          attendanceService.getCourseAttendanceStatus( token, courseID )
          .then( json => {
              dispatch({
                type: attendanceConstants.LOAD_ATTENDANCE_STATUS,
                courseAttendanceStatus: json
              })
              dispatch(viewActions.isLoadingModule('getCourseAttendanceStatus',false)) ;
          } )
          
  }
}

function getCourseAttendance( token, courseID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseAttendance',true)) ;
          attendanceService.getCourseAttendance( token, courseID )
          .then( json => {
              dispatch({
                type: attendanceConstants.SHOW_COURSE_ATTENDANCE,
                courseAttendance: json
              })
              dispatch(viewActions.isLoadingModule('getCourseAttendance',false)) ;
          } )
          
  }
}

  function postAttendance( token, studentID, calendarID, data ) { 
    return dispatch => {
            dispatch(viewActions.isLoadingModule('postAttendance',true)) ;
            attendanceService.postAttendance ( token, studentID, calendarID, data )
            .then( json => {
              json.justification_required= data.justification_required;
                dispatch({
                  type: attendanceConstants.ADD_ATTENDANCE,
                  added:json
                })
                dispatch(viewActions.isLoadingModule('postAttendance',false)) ;
            } )
            
    }
  }



function deleteAttendance( token, studentID, attendanceID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('deleteAttendance',true)) ;
          attendanceService.deleteAttendance ( token, studentID, attendanceID )
          .then( json => {
              dispatch({
                type: attendanceConstants.REMOVE_ATTENDANCE,
                deleted: {student_id: studentID, attendance_id: attendanceID }
              })
              dispatch(viewActions.isLoadingModule('deleteAttendance',false)) ;
          } )
          
  }
}
 